import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";

import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  private baseUrl = environment.apiUrl + "/api/v1/";

  constructor(private http: HttpClient, private _loc: Location) {}

  // local method
  stringToEl(string) {
    var parser = new DOMParser();
    var content: any = "text/html",
      DOM = parser.parseFromString(string, content);
    if (DOM.body.childNodes[0].childNodes.length == 0) {
      var node = document.createElement("span");
      var textnode = document.createTextNode("-");
      node.appendChild(textnode);
    }

    // return element
    return DOM.body.childNodes[0].childNodes.length != 0
      ? DOM.body.childNodes[0]
      : DOM.body.childNodes[0].appendChild(node);
  }

  goBackPrev() {
    this._loc.back();
  }

  questionDialogText(type) {
    switch (type) {
      case "R-01": {
        return "Please fill up all the fields!";
      }
      case "R-02": {
        return "Please drop all the fields in the blank!";
      }
      case "R-03": {
        return "Please drag all the fields in the blank!";
      }
      case "R-04":
      case "R-05":
      case "L-04":
      case "L-05":
      case "L-06":
      case "L-07": {
        return "Please Select Option!";
      }
      case "L-01":
      case "L-02": {
        return "Please fill up all the fields!";
      }
      case "L-03": {
        return "Please highlight in the paragraph!";
      }

      default: {
        return "-05";
      }
    }
  }

  getquestionName(questionCode: string) {
    switch (questionCode) {
      case "S001": {
        return "Read Aloud";
      }
      case "S002": {
        return "Repeat Sentence";
      }
      case "S003": {
        return "Describe Image";
      }
      case "S004": {
        return "Retell Lecture";
      }
      case "S005": {
        return "Answer Short Question";
      }
      case "L001": {
        return "Dictation";
      }
      case "L002": {
        return "Fill In The Blanks";
      }
      case "L003": {
        return "Highlight Incorrect Words";
      }
      case "L004": {
        return "MCQ Single";
      }
      case "L005": {
        return "MCQ Multiple";
      }
      case "L006": {
        return "Select Missing Word";
      }
      case "L007": {
        return "Highlight Correct Summary";
      }
      case "L008": {
        return "Summarize Spoken Text (SST)";
      }
      case "W001": {
        return "Essay Writing";
      }
      case "W002": {
        return "Summarize Written Text";
      }
      case "R001": {
        return "Reorder Paragraph";
      }
      case "R002": {
        return "Reading and Writing Fill In The Blanks (Collocation)";
      }
      case "R003": {
        return "Reading Fill In The Blanks";
      }
      case "R005": {
        return "Multiple Choice (Multiple Answer)";
      }
      case "R004": {
        return "Multiple Choice (Single Answer)";
      }
    }
  }

  getVocabName(questionCode: string) {
    switch (questionCode) {
      case "V001": {
        return "Fill In The Gaps";
      }
      case "V002": {
        return "Choose The Right Word";
      }
      case "V003": {
        return "Finish The Sentence";
      }
      case "V004": {
        return "Word Substitution";
      }
      case "V005": {
        return "Choose The Best Word";
      }
      case "V006": {
        return "Make A Collacation";
      }
    }
  }

  checkEvaluateQ(ansCount, defaultCount) {
    if (defaultCount && ansCount) return ansCount < defaultCount ? true : false;
    else return ansCount ? false : true;
  }

  getQuestionTypeListByName(moduleName: string) {
    return this.http
      .get<any>(`${this.baseUrl}${moduleName}/question-code-name`)
      .pipe(map((obj) => obj || []));
  }

  getDictionary(clicked_word: string) {
    return this.http
      .get<any>(
        "https://api.dictionaryapi.dev/api/v2/entries/en/" + clicked_word
      )
      .pipe(map((obj) => obj || {}));
  }
}
